import React from "react";
import { UiViewAll } from "./UiPageElements";

export default function UiIncentiveHistoryCard(props) {
    return (
        <>
            <div className="sb-incentive-history-card">
                <div className="sb-incentive-history-card__header">
                    <h4>{props.heading}</h4>
                </div>
                <div className='sb-incentive-history-card__body'>
                    <div className='sb-incentive-history-card__active-campaigns'>
                    {props.qtyTitle && <h5>{props.qtyTitle} {props.amount}
                        {
                            props.rightTitle &&
                            <div>{props.rightTitle} {props.rtVal}</div>
                        }                     
                        </h5>   
                    }        
                    </div>
                    {props.children}
                </div>
                {props.viewAll &&
                <div className="sb-incentive-history-card__bottom">
                    <UiViewAll />
                </div>
                }
            </div>
        </>
    );
}
